import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import krydaIcon from '../../assets/kryda-icon.png';
import './Sidebar.css';

const Sidebar = () => {
  const [isOpen, setIsOpen] = useState(true);
  const { isAdmin, isManager } = useAuth();

  const linkClass = ({ isActive }) =>
    `nav-item ${isActive ? 'active' : ''}`;

  return (
    <>
      {/* Mobile toggle */}
      <button
        className="sidebar-toggle"
        onClick={() => setIsOpen(!isOpen)}
        aria-label="Toggle sidebar"
      >
        ☰
      </button>

      <aside
        className={`sidebar ${isOpen ? 'open' : 'collapsed'}`}
        data-state={isOpen ? 'open' : 'collapsed'}
      >
        {/* Header */}
        <div className="sidebar-header">
          <img src={krydaIcon} alt="Kryda Cloud" className="sidebar-kryda-logo" />
          <div className="sidebar-header-titles">
            <span className="sidebar-title">
              {isOpen ? 'Vaultize' : 'VZ'}
            </span>
            {isOpen && (
              <span className="sidebar-subtitle">
                by Kryda Cloud
              </span>
            )}
          </div>
        </div>

        {/* Navigation */}
        <nav className="sidebar-nav">
          <NavLink
            to="/dashboard"
            className={linkClass}
            data-label="Dashboard"
            title={!isOpen ? 'Dashboard' : undefined}
          >
            <span className="nav-icon">🏠</span>
            {isOpen && <span className="nav-text">Dashboard</span>}
          </NavLink>

          <NavLink
            to="/getting-started"
            className={linkClass}
            data-label="Setup Guide"
            title={!isOpen ? 'Setup Guide' : undefined}
          >
            <span className="nav-icon">🚀</span>
            {isOpen && <span className="nav-text">Setup Guide</span>}
          </NavLink>

          <NavLink
            to="/playground"
            className={linkClass}
            data-label="Playground"
            title={!isOpen ? 'Playground' : undefined}
          >
            <span className="nav-icon">📊</span>
            {isOpen && <span className="nav-text">Playground</span>}
          </NavLink>

          <NavLink
            to="/gateway"
            className={linkClass}
            data-label="GenAI Gateway"
            title={!isOpen ? 'GenAI Gateway' : undefined}
          >
            <span className="nav-icon">🤖</span>
            {isOpen && <span className="nav-text">GenAI Gateway</span>}
          </NavLink>

          <NavLink
            to="/docs"
            className={linkClass}
            data-label="API Docs"
            title={!isOpen ? 'API Docs' : undefined}
          >
            <span className="nav-icon">📚</span>
            {isOpen && <span className="nav-text">API Docs</span>}
          </NavLink>

          <NavLink
            to="/search"
            className={linkClass}
            data-label="Search"
            title={!isOpen ? 'Search' : undefined}
          >
            <span className="nav-icon">🔎</span>
            {isOpen && <span className="nav-text">Search</span>}
          </NavLink>

          <NavLink
            to="/profile"
            className={linkClass}
            data-label="Profile"
            title={!isOpen ? 'Profile' : undefined}
          >
            <span className="nav-icon">👤</span>
            {isOpen && <span className="nav-text">Profile</span>}
          </NavLink>

          {(isAdmin || isManager) && (
            <>
              <NavLink
                to="/billing"
                className={linkClass}
                data-label="Billing"
                title={!isOpen ? 'Billing' : undefined}
              >
                <span className="nav-icon">💳</span>
                {isOpen && <span className="nav-text">Billing</span>}
              </NavLink>

              <NavLink
                to="/apikeys"
                className={linkClass}
                data-label="API Keys"
                title={!isOpen ? 'API Keys' : undefined}
              >
                <span className="nav-icon">🔑</span>
                {isOpen && <span className="nav-text">API Keys</span>}
              </NavLink>

              <NavLink
                to="/schemas"
                className={linkClass}
                data-label="Schemas"
                title={!isOpen ? 'Schemas' : undefined}
              >
                <span className="nav-icon">🧩</span>
                {isOpen && <span className="nav-text">Schemas</span>}
              </NavLink>

              <NavLink
                to="/policies"
                className={linkClass}
                data-label="Policies"
                title={!isOpen ? 'Policies' : undefined}
              >
                <span className="nav-icon">🛡️</span>
                {isOpen && <span className="nav-text">Policies</span>}
              </NavLink>



              <NavLink
                to="/settings"
                className={linkClass}
                data-label="Settings"
                title={!isOpen ? 'Settings' : undefined}
              >
                <span className="nav-icon">⚙️</span>
                {isOpen && <span className="nav-text">Settings</span>}
              </NavLink>
            </>
          )}

          {isAdmin && (
            <NavLink
              to="/admin/tenants"
              className={linkClass}
              data-label="Tenants"
              title={!isOpen ? 'Tenants' : undefined}
            >
              <span className="nav-icon">🏢</span>
              {isOpen && <span className="nav-text">Tenants</span>}
            </NavLink>
          )}
        </nav>

        {isOpen && (
          <div className="sidebar-kryda-footer">
            <img src={krydaIcon} alt="Kryda Cloud" className="sidebar-footer-logo" />
            <div className="sidebar-footer-texts">
              <span className="sidebar-footer-brand">Kryda Cloud</span>
              <span className="sidebar-footer-status">Security Active</span>
            </div>
          </div>
        )}
      </aside>
    </>
  );
};

export default Sidebar;
